import { VoucherBannerVariant } from './VoucherBanner.types'

export const VOUCHER_CAMPAIGN_ID: Record<VoucherBannerVariant, string> = {
  smava: 'c505d833-4455-448d-b0f1-08520e66854a',
  ffg: 'c5a04c21-c3e2-4a51-b41d-e4f2763ce4bf'
}

export const VOUCHER_ACTIVATION_BANNER_ID = 'voucher-activation-banner'

export const VOUCHER_TERMS_URL: Record<VoucherBannerVariant, string> = {
  smava: 'https://legal-docs.smava.de/voucherTerms.pdf',
  ffg: 'https://legal-docs.finanzcheck.de/voucherTerms.pdf'
}
